import { Alert, Dialog, DialogContent, DialogTitle, Grid, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useMemo } from 'react';
import ViewPDF from './ViewPDF';
import { faTimesCircle } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles(theme => ({
  viewDialog: {
    backgroundColor: 'rgba(0,0,0, 0.6)',
    '& .MuiDialog-paper': {
      height: 'calc(100% - 64px)',
      maxHeight: 'calc(100% - 64px)',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        margin: theme.spacing(2),
        maxHeight: 'calc(100% - 32px)'
      }
    }
  },
  title: {
    padding: theme.spacing(1, 2)
  },
  mediaContent: {
    display: 'flex',
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
    padding: theme.spacing(0, 2, 2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1, 1)
    }
  },
  mediaFrame: {
    alignItems: 'center',
    background: theme.palette.common.black,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    minHeight: 0,
    overflow: 'hidden',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '65vh',
      minHeight: 260
    }
  },
  video: {
    background: theme.palette.common.black,
    display: 'block',
    height: '100%',
    objectFit: 'contain',
    width: '100%'
  },
  image: {
    display: 'block',
    height: 'auto',
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    width: 'auto'
  }
}));

const ViewFileDialog = ({ closeViewFile, resource, viewFile }) => {
  // ****************************** STYLES ******************************
  const classes = useStyles();
  // ****************************** USE STATES ******************************

  // ****************************** USE MEMO ******************************

  //console.log(resource)
  const resourceType = useMemo(() => resource?.type?.[0] || {}, [resource?.type]);
  const { __component: type } = resourceType;

  const media_url = useMemo(() => {
    if (type !== 'resource.link') {
      return resourceType.media?.url || null;
    } else {
      return resourceType.URL || resourceType.url || null;
    }
  }, [resourceType, type]);

  // ****************************** FUNCTIONS ******************************

  //console.log(media_url);
  return (
    <Dialog
      open={viewFile}
      onClose={closeViewFile}
      aria-labelledby="resources_dialog"
      className={classes.viewDialog}
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle className={classes.title}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>{resource.name}</Grid>
          <Grid item>
            <IconButton
              aria-label="close_dialog"
              onClick={closeViewFile}
              color='secondary'
              sx={{
                fontSize: ' 2.5rem',
                '.fa-secondary' : {
                  color: '#F88F11',
                  opacity: 1
                },
                '.fa-primary' : {
                  color: '#FFF',
                },
                opacity: 1
              }}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent className={classes.mediaContent}>
        <div className={classes.mediaFrame}>
          {!media_url && ['resource.file', 'resource.image', 'resource.video'].includes(type) ? (
            <Alert severity="warning">
              This resource does not have a media file attached.
            </Alert>
          ) : type === 'resource.file' ? (
            <ViewPDF url={media_url} />
          ) : type === 'resource.video' ? (
            <video
              src={media_url}
              className={classes.video}
              controls="controls"
            // autoPlay={true}
            />
          ) : type === 'resource.image' ? (
            <img src={media_url} alt={resource.name} className={classes.image} />
          ) : type === 'resource.link' ? (
            <div>link</div>
          ) : type === 'resource.content' ? (
            <div>content</div>
          ) : null}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewFileDialog;
